import PageNotFoundAdmin from '../admin/pages/PageNotFound.svelte'
import PageNotFound from '../pages/PageNotFound.svelte'
import ItemsList from '../admin/pages/ItemsList.svelte'
import Main from '../pages/Main.svelte'
import PoliticaDePrivacidade from '../pages/PoliticaDePrivacidade.svelte'

export const pages = {
  routes: [
    {
      path: '/admin/inscritos',
      component: ItemsList,
      public: false
    },
    {
      path: '/admin/lista-de-espera',
      component: ItemsList,
      public: false
    },
    {
      path: '/admin/lista-de-desistencia',
      component: ItemsList,
      public: false
    },
    {
      path: '/admin/*',
      component: PageNotFoundAdmin,
      public: false
    },
    {
      path: '/',
      component: Main,
      public: true
    },
    {
      path: '/politica-de-privacidade',
      component: PoliticaDePrivacidade,
      public: true
    },
    {
      path: '/*',
      component: PageNotFound,
      public: true
    }
  ],
  menu: [
    {
      text: 'Inscritos',
      link: '/admin/inscritos',
      icon: '<ion-icon name="ticket-outline"></ion-icon>',
      public: false
    },
    {
      text: 'Lista de Espera',
      link: '/admin/lista-de-espera',
      icon: '<ion-icon name="cafe-outline"></ion-icon>',
      public: false
    },
    {
      text: 'Desistência',
      link: '/admin/lista-de-desistencia',
      icon: '<ion-icon name="ban-outline"></ion-icon>',
      public: false
    }
  ]
}